import { useEffect, useState } from 'react';
import { Spinner } from 'frosted-ui';

export default function LoadingScreen() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 200);
    return () => clearTimeout(t);
  }, []);

  if (!show) return null;

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'var(--color-background)',
      }}
    >
      <Spinner size="2" />
    </div>
  );
}
